<template>
  <nav class="nav">
    <a href="/" class="nav-logo">Backyard Hibachi</a>
    <a href="/booking" class="nav-cta">Book Now</a>
  </nav>
</template>

<style scoped>
.nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  padding: 1.2rem 2.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(8, 8, 8, .92);
  backdrop-filter: blur(20px);
  border-bottom: 1px solid rgba(255, 255, 255, .04);
}

.nav-logo {
  font-family: 'Noto Serif JP', serif;
  font-size: 1.2rem;
  color: var(--gold);
  font-weight: 700;
  letter-spacing: .12em;
}

.nav-location {
  position: relative;
  margin-left: auto;
  margin-right: 1.2rem;
}

.nav-location-trigger {
  appearance: none;
  border: 0;
  background: transparent;
  padding: 0;
  cursor: pointer;
  color: rgba(255, 255, 255, .68);
  font-size: .72rem;
  font-family: inherit;
  font-weight: 700;
  letter-spacing: .18em;
  text-transform: uppercase;
  transition: color .25s;
}

.nav-location-trigger::after {
  content: '';
  color: var(--gold);
  margin-left: .45rem;
  letter-spacing: 0;
}

.nav-location:hover .nav-location-trigger,
.nav-location:focus-within .nav-location-trigger {
  color: var(--gold);
}

.location-menu {
  position: absolute;
  top: calc(100% + 1rem);
  right: 0;
  width: 270px;
  padding: .55rem;
  background: rgba(12, 12, 12, .98);
  border: 1px solid rgba(212, 165, 116, .24);
  box-shadow: 0 24px 54px rgba(0, 0, 0, .48);
  opacity: 0;
  pointer-events: none;
  transform: translateY(8px);
  transition: opacity .2s, transform .2s;
}

.nav-location:hover .location-menu,
.nav-location:focus-within .location-menu {
  opacity: 1;
  pointer-events: auto;
  transform: translateY(0);
}

.location-menu a {
  display: block;
  padding: .8rem .9rem;
  color: rgba(255, 255, 255, .72);
  font-size: .78rem;
  letter-spacing: .06em;
  transition: background .25s, color .25s;
}

.location-menu a:hover {
  background: rgba(212, 165, 116, .1);
  color: var(--gold);
}

.nav-events {
  margin-left: auto;
  margin-right: 1.4rem;
  color: rgba(255, 255, 255, .68);
  font-size: .72rem;
  font-weight: 700;
  letter-spacing: .18em;
  text-transform: uppercase;
  transition: color .25s;
}

.nav-events:hover {
  color: var(--gold);
}

.nav-cta {
  padding: .7rem 1.8rem;
  border: 1px solid rgba(212, 165, 116, .5);
  color: var(--gold);
  font-size: .7rem;
  letter-spacing: .2em;
  text-transform: uppercase;
  transition: all .3s;
}

.nav-cta:hover {
  background: var(--gold);
  color: #000;
}

@media (max-width: 640px) {
  .nav {
    padding: .9rem 1rem;
    gap: .8rem;
  }

  .nav-logo {
    font-size: .9rem;
    letter-spacing: .08em;
  }

  .nav-location {
    margin: 0;
  }

  .nav-location-trigger {
    font-size: .66rem;
    letter-spacing: .1em;
  }

  .location-menu {
    position: fixed;
    top: 62px;
    left: 1rem;
    right: 1rem;
    width: auto;
  }

  .location-menu a {
    min-height: 44px;
    display: flex;
    align-items: center;
  }

  .nav-events {
    display: none;
  }

  .nav-cta {
    padding: .55rem .8rem;
    font-size: .62rem;
    letter-spacing: .12em;
  }
}
</style>